"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
exports.withLoading = function (Component) { return function (props) {
    var isLoading = props.isLoading, leftIcon = props.leftIcon, rest = __rest(props, ["isLoading", "leftIcon"]);
    var loadingIcon = { name: 'spinner', animate: true };
    return React.createElement(Component, __assign({}, rest, { leftIcon: isLoading ? loadingIcon : leftIcon }));
}; };
exports.default = exports.withLoading;
//# sourceMappingURL=withLoading.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/hocs/common/withLoading.js
// module id = 348
// module chunks = 0 1